export default __webpack_public_path__ + "static/media/spite.a07af7b3.svg";